import { useStateValue } from 'context/store'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

const ProfileStyles = makeStyles(theme => ({
   profileContainer: {
      padding: theme.spacing(2, 3),
      display: 'flex',
      flexDirection: 'column',
      minWidth: 300
   },
   titleContainer: {
      marginBottom: theme.spacing(1),
      display: 'flex'
   },
   title: {
      fontSize: 18,
      fontWeight: 'bold',
      margin: 'auto'
   },
   backButton: {
      cursor: 'pointer'
   }
}))

function ProfileDetail({ setCurrentView }) {
   const classes = ProfileStyles()
   const [
      {
         sessionUser: { settings = {} }
      }
   ] = useStateValue()

   // TODO: adaptar y usar el custom hook useGetUserSettings
   const {
      documentNumber,
      documentType,
      name,
      lastName,
      email,
      entity: { name: entityName },
      thirdPartyType
   } = settings

   function handleBackButtonClick() {
      setCurrentView('profileView')
   }

   return (
      <Grid className={classes.profileContainer}>
         <Grid className={classes.titleContainer}>
            <ArrowBackIcon
               className={classes.backButton}
               onClick={handleBackButtonClick}
            />
            <Typography className={classes.title}>Perfil</Typography>
         </Grid>
         <Grid>
            <UserInfoData label="Tipo de identificación" data={documentType} />
            <UserInfoData
               label="Nro. de Identificación"
               data={documentNumber}
            />
            <UserInfoData
               label="Nombre y Apellido"
               data={`${name} ${lastName}`}
            />
            <UserInfoData label="Correo Electrónico" data={email} />
            <UserInfoData label="Entidad" data={entityName} />
            <UserInfoData label="Tipo de Tercero" data={thirdPartyType} />
         </Grid>
      </Grid>
   )
}

export default ProfileDetail

// ---------------------------------------

const UserDataStyles = makeStyles(theme => ({
   userDataContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: theme.spacing(2),
      minHeight: 36
   },
   label: {
      color: '#1665D8',
      fontSize: 11
   },
   data: {
      fontSize: 16
   }
}))

function UserInfoData({ label, data }) {
   const classes = UserDataStyles()
   return (
      <Grid className={classes.userDataContainer}>
         <div className={classes.label}>{label}</div>
         <div className={classes.data}>{data || 'No registra'}</div>
      </Grid>
   )
}
